import React from "react";
import { Modal } from "reactstrap";
import AppButton from "components/app-button";

const AppConfirmationModal = ({ isOpen, noOnClick, label, confirmOnClick }) => {
    return (
        <Modal isOpen={isOpen} className="app-confirmation-modal" contentClassName="app-confirmation-modal__content">
            <div className="app-confirmation-modal__label">{label}</div>
            <div className="app-confirmation-modal__buttons-row">
                <div className="app-confirmation-modal__button-wrapper">
                    <AppButton colorType="orange" label="Yes" onClick={confirmOnClick}/>
                </div>
                <div className="app-confirmation-modal__button-gap"/>
                <div className="app-confirmation-modal__button-wrapper">
                    <AppButton colorType="orange" label="No" onClick={noOnClick} />
                </div>
            </div>
        </Modal>
    );
};

export default AppConfirmationModal;
